import { Typewriter } from './Typewriter';
import { KWELLO_ICON, KwelloSvgIcon } from '../../../components/icon/KwelloSvgIcon';

export const ServerThinkingCard = () => {
  const textValues = [
    `Searching your filtered records...`,
    'Analyzing the most relevant records...',
    'Combining results...',
    'Preparing output...',
  ];

  return (
    <>
      <div className="server-waiting">
        <KwelloSvgIcon icon={KWELLO_ICON.LIGHT_BULB_ICON} />
        <div className="text-values">
          <Typewriter textValues={textValues} />
        </div>
      </div>
    </>
  );
};
